import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { PasswordPolicyState } from './password-policy-state.modal';

@Injectable({
  providedIn: 'root'
})
export class PasswordPolicyService {

  private passwordPolicySubject = new Subject<PasswordPolicyState>();
  policyState = this.passwordPolicySubject.asObservable();
  constructor() { }
  show(password: string) {
    this.passwordPolicySubject.next({ show: true, password } as PasswordPolicyState);
  }
  hide() {
    this.passwordPolicySubject.next({ show: false, password: '' } as PasswordPolicyState);
  }
  length(password: string) {
    return password.length >= 15;
  }

  capital(password: string) {
    return password.match(/[A-Z]/g);
  }

  small(password: string) {
    return password.match(/[a-z]/g);
  }

  number(password: string) {
    return password.match(/\d/g);
  }

  symbol(password: string) {
    return password.match(/([!@#$%^&*\.\-_+=[\]{}|\\:',?/`~"();])+/g)
      && password.match(/(^([0-9A-Za-z\d@#$%^&*\.\-_+=[\]{}|\\:',?/`~"();!])+$)/g);
  }

  valid(password: string) {
    return (this.symbol(password) &&
      this.length(password) &&
      this.capital(password) &&
      this.small(password) &&
      this.number(password));
  }
}
